import Vue from "vue";

import "vue-awesome/icons/envelope";
import "vue-awesome/icons/map";
import "vue-awesome/icons/phone";

import Icon from "vue-awesome/components/Icon";

Vue.component("v-icon", Icon);
